<template>
	<div class="successfully-joined">
		<ProfilePic :user="invite.organization" class="org-logo" size="80px" />

		<div class="title">{{ invite.organization.name }}</div>
		<i18n-t
			keypath="groupinvites_signup_join_group_label"
			class="description"
			tag="div"
			v-if="invite.group"
		>
			<template #GroupName>
				<strong>{{ invite.group.title }}</strong>
			</template>
		</i18n-t>
		<hr />
		<div class="step">{{ $t('common_step_number', { Step: 1 }) }}</div>
		<div class="step-hint">
			{{ $t('onboarding_mobileprompt_step_one_description') }}
		</div>
		<div class="app-links">
			<a
				v-if="isApple"
				href="https://apps.apple.com/us/app/pronto-team-communication/id1258991852"
				target="_blank"
				class="appstore"
				><AppStoreIcon
			/></a>
			<a
				v-if="isAndroid"
				href="https://play.google.com/store/apps/details?id=com.hitlabs.pronto&hl=en_US"
				target="_blank"
				><PlayStoreIcon
			/></a>
		</div>

		<hr />
		<div class="step">{{ $t('common_step_number', { Step: 2 }) }}</div>
		<div class="step-hint">
			{{ $t('onboarding_mobileprompt_step_two_description') }}
		</div>

		<Button large block pronto :href="link" newTab class="redeem-btn">
			{{ $t('onboarding_mobileprompt_redeem_button') }}
		</Button>
	</div>
</template>

<script>
import { getEnv } from '@/helperMethods'
import { PlayStoreIcon, AppStoreIcon } from '@/icons'
import { Button, ProfilePic } from '@/components/common'
import { getInvite } from './index'
import { browser } from '@/store'

export default {
	components: { PlayStoreIcon, AppStoreIcon, Button, ProfilePic },

	data() {
		return { invite: { organization: {} } }
	},

	mounted() {
		this.invite = getInvite()
	},

	computed: {
		isApple() {
			return browser.os === 'iOS'
		},
		isAndroid() {
			return browser.os === 'Android OS'
		},
		link() {
			// because of iOS/Android rules for opening web links in other apps, the only
			// way to open the pronto app reliably is to use the pronto:// custom scheme
			const scheme = ['local', 'dev'].includes(getEnv())
				? 'pronto-dev'
				: 'pronto'
			return `${scheme}://invites/${this.invite.code}`
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.successfully-joined {
	display: flex;
	flex-direction: column;
	align-items: center;

	.org-logo {
		margin-bottom: 13px;
	}

	text-align: center;
	font-family: Avenir;

	.title {
		font-size: 28px;
		color: var(--neutral-800);
		margin-bottom: 16px;
	}

	.description {
		font-size: 14px;
		color: $neutral-500;
	}

	hr {
		width: 100%;
		height: 1px;
		border: none;
		background-color: var(--neutral-200);
		margin: 24px 0;
	}

	.step {
		font-family: map-get($fonts, 500);
		font-size: 20px;
		text-align: center;
		color: var(--neutral-800);
		margin-bottom: 8px;
	}

	.step-hint {
		font-family: map-get($fonts, 500);
		font-size: 14px;
		text-align: center;
		color: $neutral-500;
		padding: 0 20px;
		margin-bottom: 24px;
	}

	.redeem-btn {
		margin-bottom: 90px;
	}
}
</style>
